import { z } from 'zod'

export const TokenLimitResponseSchema = z.object({
  max_tokens: z.number(),
  chunk_size: z.number(),
})

export type TokenLimitResponse = z.infer<typeof TokenLimitResponseSchema>
